// eslint-disable-next-line no-unused-vars
import React from 'react';
import { bool, func, node, string } from 'prop-types';
import { ComposedModal, ModalBody, ModalHeader } from '@carbon/react';
import styled from '@emotion/styled';
import { useTheme } from '@emotion/react';

const StyledComposedModal = styled(ComposedModal)`
  overflow: visible;

  .cds--modal-container {
    overflow: visible;
  }
`;

const StyledModalBody = styled(ModalBody)`
  overflow-y: auto;
  background-color: ${ props => props.theme.colors.white };
  color: ${ props => props.theme.colors.darkGray };
  margin-bottom: 0;
  padding: 0 !important;
  font-size: 0.875rem;
`;

const AddToWishlistModal = ({
  open,
  title,
  onClose,
  children
}) => {
  const theme = useTheme();

  return (
    <StyledComposedModal
      open={ open }
      onClose={ onClose }
      size="sm"
      className="AddToWishlistModal"
      selectorPrimaryFocus=".cds--modal-content"
    >
      <ModalHeader>
        <h4>{ title }</h4>
      </ModalHeader>
      <StyledModalBody theme={ theme }>
        { children }
      </StyledModalBody>
    </StyledComposedModal>
  );
};

AddToWishlistModal.propTypes = {
  open: bool,
  title: string,
  onClose: func,
  children: node
};

export default AddToWishlistModal;
